import React, { useMemo, useState } from "react";
import { useQuery } from "@apollo/client/react";
import { useFormikContext } from "formik";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import MissingCenterRackSelect from "./MissingCenterRackSelect";
import { WAREHOUSE_LOCATION_MISSING_CENTERS } from "../../../../constants/graphql/queries";
import { text } from "./modalStyles";

const isActive = location => location?.active !== false;

export default function MissingCentersCreation({ warehouseId }) {
  const { setFieldValue, errors, submitCount } = useFormikContext();
  const [selected, setSelected] = useState([]);
  const { data, loading } = useQuery(WAREHOUSE_LOCATION_MISSING_CENTERS, {
    variables: { warehouseId },
    fetchPolicy: "network-only",
    skip: !warehouseId,
  });

  const racks = useMemo(
    () =>
      (data?.warehouseLocationMissingCenters || []).filter(
        bay => isActive(bay.leftLocation) && isActive(bay.rightLocation)
      ),
    [data]
  );
  const selectionError = submitCount > 0 && errors.leftLocationIds;

  const persistSelection = bays => {
    setSelected(bays);
    setFieldValue(
      "leftLocationIds",
      bays.map(bay => bay.leftLocation.id)
    );
    setFieldValue(
      "missingCenterNames",
      bays.map(bay => bay.baseName)
    );
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={4}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (racks.length === 0) {
    return (
      <Typography sx={{ ...text.help, mt: 0.5 }}>
        No Left/Right racks in this warehouse are missing a Center.
      </Typography>
    );
  }

  return (
    <Box>
      <Typography sx={{ ...text.help, mb: 1.5 }}>
        Search for the rack location(s) you'd like to add a Center to
      </Typography>
      <MissingCenterRackSelect options={racks} value={selected} onChange={persistSelection} />
      {selectionError && (
        <Typography sx={{ ...text.help, color: "error.main", mt: 1 }}>
          {selectionError}
        </Typography>
      )}
    </Box>
  );
}
